import React from 'react'
import SendBTN from '../../../src/images/send_message.svg';
import { useState, useContext, useRef } from 'react';
import UserContext from '../../context/UserContext';


function debounce(func, wait) {
  let timeout;
  return function(...args) {
      const later = () => {
          clearTimeout(timeout);
          func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
  };
}


export default function WritingMessageBox() {

    const [message, setMessage] = useState("")
    const messageField = useRef(null)


    const appContext = useContext(UserContext)

    console.log(appContext)


    function generateUniqueString() {
      // Current time in milliseconds, converted to base-36
      var timePart = Date.now().toString(36);
  
      // Random number, converted to base-36
      var randomPart = Math.random().toString(36).substring(2, 15);
  
      // High resolution time component for added uniqueness
      var performancePart = '';
      if (window.performance && window.performance.now) {
          performancePart = performance.now().toString(36).replace('.', '');
      }
  
      // Combine all parts
      return timePart + '-' + randomPart + '-' + performancePart;
  }


  function formatGmtTimestamp() {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'GMT',
        hour12: false
    });

    const [
        { value: month },,
        { value: day },,
        { value: year },,
        { value: hour },,
        { value: minute },,
        { value: second }
    ] = formatter.formatToParts(now);

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}


    const sendMessage = () =>{

      var myMessage = message.trim();

      if(myMessage.length > 0)
      {

      console.log("sending a message from customer")

      appContext.updatenumberofchats()
        const customerCookie = appContext.getCookie('customer_id_ex');
        //console.log("This is my cookie: " + customerCookie)

        var arr1 = appContext.listofMessages
        const uniq = generateUniqueString();

        arr1.push({
          message: message,
          sender: "customer",
          datemade: formatGmtTimestamp(),
          unique: uniq
        })

        appContext.setListOfMessages(arr1)

        //-----

        const payload = {message: message, customer_id: customerCookie, 
          unique: uniq, unique_session_id: appContext.unique_session_id}

        const obj1 = {action: "customer_sends_message", payload: payload}

        console.log("----> 1. i have set the message ----- " + appContext.unique_session_id);

        appContext.socket.send(JSON.stringify(obj1));
        setMessage("");

        messageField.current.value = ""

      }
    }


    const handleEnterPress = (e) => {
      if (e.key === 'Enter') {
        sendMessage();
      }
    };


// Function to call when typing in the textarea
function handleTextChange(text) {

  const payload = {
    unique_session_id: appContext.unique_session_id,
    text: text,
    owner_token: appContext.owner_token,
    customer_id: appContext.getCookie('customer_id_ex')
  }
  const obj1 = {action: "customer_types_message", payload: payload}
  
  appContext.socket.send(JSON.stringify(obj1));

}

// Debounced version of the above function
const debouncedTextChange = debounce(handleTextChange, 900); // 500 ms delay

// Event handler for the textarea change
function onChangeHandler(event) {
  setMessage(event.target.value);
  debouncedTextChange(event.target.value);
}


function paperClipIcon()
{
  return(<svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7583 0.750097C16.4689 0.745795 17.1729 0.884287 17.8293 1.15715C18.4858 1.42999 19.0812 1.83157 19.5815 2.33783C20.0817 2.84407 20.4769 3.44493 20.7449 4.10519C21.0129 4.76543 21.1485 5.47241 21.1443 6.1853C21.1401 6.89819 20.9961 7.60349 20.7203 8.26045C20.4455 8.9151 20.045 9.50922 19.5412 10.0082L11.4822 18.1524L11.4754 18.159C10.8671 18.7555 10.0857 19.2189 9.15886 19.2373C8.21636 19.2561 7.39193 18.8102 6.72174 18.1381C5.91136 17.3254 5.68571 16.3423 5.80354 15.4664C5.91409 14.6445 6.31945 13.93 6.76671 13.4628L6.77354 13.4557L13.2747 6.87675C13.5658 6.58212 14.0407 6.5793 14.3353 6.87044L15.0466 7.57333C15.3413 7.86448 15.3441 8.33934 15.0529 8.63397L8.56738 15.1971C8.44404 15.3286 8.3128 15.5649 8.28123 15.7997C8.26687 15.9064 8.27488 15.9977 8.29992 16.0775C8.32376 16.1535 8.37372 16.2542 8.49207 16.3729C8.83879 16.7206 9.04311 16.7391 9.10912 16.7378C9.19021 16.7362 9.39502 16.6956 9.71903 16.3799L17.7739 8.23989L17.779 8.23486C18.0499 7.96733 18.2664 7.64724 18.4152 7.29271C18.5641 6.93816 18.6421 6.55669 18.6444 6.17052C18.6467 5.78436 18.5731 5.40188 18.4285 5.0454C18.2838 4.68895 18.071 4.36605 17.8032 4.09506C17.5355 3.8241 17.2181 3.61043 16.8698 3.46567C16.5216 3.32093 16.149 3.24778 15.7735 3.25005C15.398 3.25232 15.0263 3.32999 14.6798 3.47893C14.3334 3.62789 14.0186 3.84538 13.7542 4.11955L13.7489 4.12501L5.63139 12.3396L5.62494 12.346C5.19479 12.7689 4.8512 13.2749 4.61488 13.835C4.37855 14.3952 4.25443 14.9979 4.25012 15.608C4.24581 16.2181 4.3614 16.8226 4.58984 17.3864C4.7994 17.9036 5.31873 18.6255 5.78425 19.0965C6.26632 19.5844 7.0868 20.2047 7.57895 20.409C8.13199 20.6385 8.72402 20.7542 9.32077 20.7499C9.91752 20.7456 10.5078 20.6213 11.0575 20.3838C11.6072 20.1463 12.1057 19.8002 12.5237 19.3648L12.5299 19.3583L20.4623 11.331C20.7535 11.0363 21.2283 11.0335 21.523 11.3247L22.2343 12.0276C22.5289 12.3187 22.5317 12.7936 22.2406 13.0882L14.3206 21.103C13.6745 21.7742 12.9026 22.31 12.049 22.6788C11.1924 23.0488 10.2712 23.2431 9.33887 23.2498C8.40657 23.2566 7.48259 23.0757 6.62078 22.7181C5.69809 22.3352 4.60526 21.4602 4.00601 20.8538C3.39021 20.2306 2.64342 19.2398 2.27283 18.3252C1.9211 17.4572 1.74356 16.5276 1.75018 15.5903C1.7568 14.6531 1.94746 13.7261 2.31147 12.8633C2.67425 12.0034 3.20221 11.2237 3.86555 10.5699L11.9603 2.37823C12.4533 1.86865 13.0418 1.46191 13.6924 1.1822C14.3455 0.901404 15.0478 0.754399 15.7583 0.750097Z" fill="#fff"/>
  </svg>)
}


function sendChatIcon()
{
  return(<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.3009 13.6949L20.102 3.89742M10.5795 14.1355L12.8019 18.5804C13.339 19.6545 13.6075 20.1916 13.9458 20.3356C14.2394 20.4606 14.575 20.4379 14.8492 20.2747C15.1651 20.0866 15.3591 19.5183 15.7472 18.3818L19.9463 6.08434C20.2845 5.09409 20.4535 4.59896 20.3378 4.27142C20.2371 3.98648 20.013 3.76234 19.7281 3.66167C19.4005 3.54595 18.9054 3.71502 17.9151 4.05315L5.61763 8.2523C4.48114 8.64037 3.91289 8.83441 3.72478 9.15032C3.56153 9.42447 3.53891 9.76007 3.66389 10.0536C3.80791 10.3919 4.34498 10.6605 5.41912 11.1975L9.86397 13.42C10.041 13.5085 10.1295 13.5527 10.2061 13.6118C10.2742 13.6643 10.3352 13.7253 10.3876 13.7933C10.4468 13.87 10.491 13.9585 10.5795 14.1355Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>)
}


  return (
    <div>
        
        <div className="ecd-flex ecd-writing-box">
                <div className='ecd-flex-grow'>
                    <textarea  ref={messageField} className="ecd-messageTextArea"
                    onKeyDown={handleEnterPress} onChange={onChangeHandler}
                    ></textarea>
                </div>

                <div className='ecd-flex-shrink' style={{flexDirection:"row", marginTop:9, paddingRight:5, display:'flex'}}>
                <div style={{paddingTop: 0}}>
                  <button className='chatButton1' style={{background:"transparent",   paddingTop:5, paddingBottom:5, border: 0, cursor:"pointer"}}>
                    {paperClipIcon()}
                  </button></div>

                  <div style={{paddingTop: 0}}>
                <button className='chatButton1' onClick={() =>{ sendMessage() }} disabled={message ? false : true} 
                style={{background:message ? "red" : "none",  cursor:"pointer", paddingTop:4, border:"none"}}>
                  {sendChatIcon()}</button>
                </div></div>
                    
        </div>

    </div>
  )
}
